import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ItemAction } from "store/actions";
import { CartAction } from "store/actions";
import { NotPersistAction } from "store/actions";
import { TRACKING_EVENTS } from "utils";
import { errorNotification } from "utils/Utils";
import { t } from "i18next";
import { useEffect } from "react";
import reduxstore from "store/store";
import { PLACEHODERIMAGE } from "Constants/constants";

function useAddItemToBasket() {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const { requiredMissingSections } = useSelector((state) => state?.NotPersist);

  useEffect(() => {
    showError();
  }, [requiredMissingSections]);

  const showError = (id) => {
    if (requiredMissingSections?.length > 0) {
      const section = requiredMissingSections?.[0]?.modifierGroupId;
      if (section?._id || id) {
        const optionId = document.getElementById(section._id || id);
        optionId?.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const checkItemAndOptions = (userSections, currentItem, setErrorMessage) => {
    const missingSections = [];
    let optionsValid = true;
    const userSectionsMap = new Map(
      userSections?.map((section) => [section?._id, section])
    );

    for (const group of currentItem?.itemInfo?.modifierGroups || []) {
      const numSelectedOptions =  (userSectionsMap?.get(group?.modifierGroupId?._id) || { options: [] })?.options?.reduce((acc, option) => acc + option.quantity, 0);
      if (numSelectedOptions < group?.modifierGroupId.minimumAllowedSelection) {
        const message = t("Please select at least xoptions options from the xgroup section to proceed", {
          minimum: group?.modifierGroupId?.minimumAllowedSelection,
          groupname: group?.modifierGroupId?.baseLanguage?.name,
          option: group.modifierGroupId.minimumAllowedSelection === 1 ? t("side") : t("sides"),
        });
        if(setErrorMessage){
          setErrorMessage(message);
        } else {  
        errorNotification(
          message
        );}

        missingSections.push(group);
        showError(group?.modifierGroupId?._id);
        dispatch(NotPersistAction.setRequiredMissingSections(missingSections));

        optionsValid = false;
        return false;
      }
      if (
        group?.modifierGroupId.minimumAllowedSelection > 0 &&
        !userSectionsMap.has(group?.modifierGroupId?._id)
      ) {
        missingSections.push(group);
      }
    }

    // if (missingSections?.length > 0) {
    //   dispatch(NotPersistAction.setRequiredMissingSections(missingSections));
    //   showError();
    //   errorNotification(
    //     t(
    //       "Please select at least xoptions options from the xgroup section to proceed",
    //       {
    //         minimum:
    //           missingSections[0]?.modifierGroupId?.minimumAllowedSelection,
    //         groupname: missingSections[0]?.modifierGroupId?.baseLanguage?.name,
    //         option:
    //           missingSections[0].modifierGroupId.minimumAllowedSelection === 1
    //             ? t("side")
    //             : t("sides"),
    //       }
    //     )
    //   );

    //   return false;
    // }

    return optionsValid;
  };

  const goBack = window?.history?.back || history.goBack;
  const addItemToBasket = (
    brandInfo,
    selectedItem,
    singleItem,
    itemSection,
    handleBack=()=>{},
    setErrorMessage,
    discount
  ) => {
    if (!brandInfo?.brand?._id || !selectedItem?.itemInfo || !singleItem) {
      goBack();
      return;
    }
  
    const { itemInfo } = selectedItem;
    
    // item.price is being saves as per item qunatity, we are multiplying the quantity with item price at runtime
    const itemObj = {
      brandId: brandInfo.brand._id,
      sku: itemInfo?.sku,
      itemId: itemInfo?._id,
      quantity: singleItem?.quantity,
      discountOnItem: discount,
      price: discount?.discountedPrice ? discount?.discountedPrice : singleItem?.price,
      baseLanguage: {
        ...itemInfo.baseLanguage,
        ingredients: "",
      },
      sections: itemSection,
      categoryId: params?.catId,
      ...(itemInfo?.externalData && {
        externalData: itemInfo.externalData,
      }),
      availableStock: selectedItem?.availableStock || 0,
      isOutOfStock: selectedItem?.isOutOfStock || false,
      isStockEnabled: selectedItem?.isStockEnabled || false,
      mediaUrl: itemInfo?.itemImageURLs?.[0] ??  PLACEHODERIMAGE,
      
    };
  
    const isItemAndOptionsValid = checkItemAndOptions(
      itemObj.sections,
      selectedItem,
      setErrorMessage
    );
  
    if (!isItemAndOptionsValid) return;
  
    // Check if item already exists in cart with same itemId
    const currentCart = reduxstore.getState().cart.cart;
  
    const isSameOptions = (a, b) => {
      return JSON.stringify(a) === JSON.stringify(b);
    };
  
    const existingItemIndex = currentCart.findIndex(cartItem => {
      const sameItemId = cartItem.itemId === itemObj.itemId;
      const bothHaveOptions = cartItem.sections && itemObj.sections;
      const neitherHaveOptions = !cartItem.sections && !itemObj.sections;
  
      if (sameItemId && (bothHaveOptions || neitherHaveOptions)) {
        if (bothHaveOptions) {
          return isSameOptions(cartItem.sections, itemObj.sections);
        }
        return true; // Neither have options
      }
  
      return false;
    });
  
    if (existingItemIndex !== -1) {
      // Increase quantity if matching item found
      const existingItem = currentCart[existingItemIndex];
      const newQuantity = existingItem.quantity + itemObj.quantity;
      
      // Check stock limit
      if (existingItem.isStockEnabled && newQuantity > existingItem.availableStock) {
        if(setErrorMessage){
          setErrorMessage(t("Maximum available quantity reached"));
        } else {
          errorNotification(
            t(
              "Maximum available quantity reached",
            )
          );
        }
        return;
      }
      
      const updatedItem = {
        ...existingItem,
        quantity: newQuantity,
      };
  
      dispatch(CartAction.updateCartItem({ index: existingItemIndex, updatedItem }));
    } else {
      // Add new item
      dispatch(CartAction.addItemToCart(itemObj));
    }
  
    TRACKING_EVENTS.AddToCart(itemObj);

    // Leaving this screen is deferred by a beat so the pixel event can leave
    // the browser first.
    //
    // Facebook's pixel sends synchronously, so its AddToCart always arrived.
    // TikTok's SDK queues the event and flushes it asynchronously, and this
    // screen navigates away immediately -- the queued request was discarded
    // every time, which is why TikTok only ever recorded page views. Verified
    // by calling ttq.track by hand, which produced the request normally.
    //
    // 250ms is not perceptible after a tap and costs nothing when no pixel is
    // configured.
    setTimeout(() => {
      handleBack();
      dispatch(ItemAction.clearItem());
    }, 250);
  };
  
  return {
    addItemToBasket,
  };
}

export default useAddItemToBasket;
